<template>
  <div v-if="showMessage" class="cookies-message-overlay">
    <div class="cookies-message">
      <div class="cookies-content">
        <div class="cookies-text">
          <h3 class="cookies-title">{{ $t('cookies_title') }}</h3>
          <p class="cookies-description">{{ $t('cookies_message') }}</p>
        </div>
      </div>
      <div class="cookies-actions">
        <button class="cookies-button accept" @click="acceptCookies">
          {{ $t('cookies_accept') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CookiesMessage',
  data() {
    return {
      showMessage: false,
      hasIcon: false
    }
  },
  mounted() {
    this.checkCookiesConsent()
    this.checkIconAvailability()
  },
  methods: {
    checkCookiesConsent() {
      const lastShown = localStorage.getItem('cookiesMessageShown')
      const oneWeekAgo = Date.now() - (7 * 24 * 60 * 60 * 1000) // 7 days in milliseconds
      console.log({
        lastShown
      });
      if (!lastShown || parseInt(lastShown) < oneWeekAgo) {
        this.showMessage = true
      }
    },
    acceptCookies() {
      localStorage.setItem('cookiesMessageShown', Date.now().toString())
      this.showMessage = false
    },
    checkIconAvailability() {
      // Check if fp-icon component is available
      this.hasIcon = this.$options.components && this.$options.components.FpIcon
    }
  }
}
</script>

<style scoped lang="scss">
.cookies-message-overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(2px);
  padding: 1rem;
}

.cookies-message {
  background: #000000d6;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: .5rem;
  max-width: 600px;
  margin: 0 auto;
  border: 1px solid #e0e0e06e;
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.cookies-content {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.cookies-text {
  flex: 1;
}

.cookies-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #fff;
  line-height: 1.4;
}

.cookies-description {
  font-size: 0.9375rem;
  color: #fff;
  margin: 0;
  line-height: 1.5;
}

.cookies-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
}

.cookies-button {
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-size: 0.9375rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;

  &.accept {
    background: var(--primary, #007bff);
    color: white;

    &:hover {
      background: var(--primary-dark, #0056b3);
      transform: translateY(-1px);
    }
  }
}

// Mobile responsive design
@media (max-width: 768px) {
  .cookies-message-overlay {
    padding: 0.5rem;
  }

  .cookies-message {
    padding: 1rem;
  }

  .cookies-content {
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }

  .cookies-icon {
    align-self: center;
  }

  .cookies-title {
    font-size: 1rem;
  }

  .cookies-description {
    font-size: 0.875rem;
  }

  .cookies-actions {
    justify-content: center;
  }

  .cookies-button {
    padding: 0.875rem 2rem;
    font-size: 1rem;
  }
}

// RTL support
.rtl {
  .cookies-content {
    text-align: right;
  }

  .cookies-actions {
    justify-content: flex-start;
  }

  @media (max-width: 768px) {
    .cookies-content {
      text-align: center;
    }

    .cookies-actions {
      justify-content: center;
    }
  }
}
</style>